module.exports = __webpack_public_path__ + "img/hovered-layer7.83caca51.png";